import { render, staticRenderFns } from "./mobile_detail_card.vue?vue&type=template&id=22e6e318&scoped=true&"
import script from "./mobile_detail_card.vue?vue&type=script&lang=js&"
export * from "./mobile_detail_card.vue?vue&type=script&lang=js&"
import style0 from "./mobile_detail_card.vue?vue&type=style&index=0&id=22e6e318&scoped=true&lang=css&"
import style1 from "./mobile_detail_card.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e6e318",
  null
  
)

export default component.exports